<div class="min-h-screen flex flex-col bg-white font-sans">
  
  <div class="flex-grow flex flex-col items-center justify-center px-4">

    <div class="text-center mb-8">
      <img src="../../../assets/icons/techsurance-logo.png" 
           class="mx-auto h-24 w-auto mb-4" alt="Techsurance Logo" />
      <h1 class="text-2xl font-bold text-gray-900 tracking-tight mb-1">Techsure Learn</h1>
      <p class="text-gray-600 italic text-sm sm:text-base">
        {{ isLoginMode ? 'Welcome back to your induction' : 'Start your induction training' }}
      </p>
    </div>

    <!-- STEP 1: Request OTP -->
    <ng-container *ngIf="step === 1">
      <form [formGroup]="authForm" (ngSubmit)="requestOtp()" class="w-full max-w-[320px] sm:max-w-md space-y-5">
        
        <div class="space-y-4">
          <!-- Full Name (Hidden in Login Mode) -->
          <input *ngIf="!isLoginMode"
                 type="text" 
                 class="w-full px-4 py-3 rounded-lg bg-[#E9F0E6] border border-gray-200 text-gray-700 placeholder:text-gray-500 focus:ring-2 focus:ring-[#1D4586] outline-none transition-all" 
                 placeholder="Full Name"
                 formControlName="name" />

          <!-- Email -->
          <input type="email" 
                 class="w-full px-4 py-3 rounded-lg bg-[#E9F0E6] border border-gray-200 text-gray-700 placeholder:text-gray-500 focus:ring-2 focus:ring-[#1D4586] outline-none transition-all" 
                 placeholder="Work Email" 
                 formControlName="email" />
        </div>

        <button type="submit" 
                class="w-full bg-[#1D4586] text-white py-3 rounded-lg font-semibold text-lg flex items-center justify-center hover:bg-[#16366b] transition-colors disabled:opacity-50 disabled:cursor-not-allowed" 
                [disabled]="authForm.invalid || isLoading">
          <svg *ngIf="isLoading" class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          {{ isLoading ? 'Sending OTP...' : (isLoginMode ? 'Log In' : 'Sign Up') }}
        </button>

        <div class="text-center mt-4">
          <button type="button" (click)="toggleMode()" class="text-sm font-semibold text-[#1D4586] hover:underline">
            {{ isLoginMode ? 'New joinee? Sign up here' : 'Already registered? Log in here' }}
          </button>
        </div>
        
        <div class="text-center mt-2">
          <a routerLink="/login" class="text-xs font-semibold text-gray-500 hover:text-gray-800">
            &larr; Back to selection
          </a>
        </div>
      </form>
    </ng-container>

    <!-- STEP 2: Verify OTP -->
    <!-- STEP 2: Verify OTP -->
    <ng-container *ngIf="step === 2">
      <form [formGroup]="otpForm" (ngSubmit)="verifyOtp()" class="w-full max-w-[320px] sm:max-w-md space-y-6">
        
        <div class="text-center mb-2">
          <p class="text-sm text-gray-600">Enter the 6-digit code sent to<br/><span class="font-bold">{{ currentEmail }}</span></p>
        </div>

        <!-- 6 OTP Boxes -->
        <div class="flex justify-center gap-2 sm:gap-3">
          <input *ngFor="let i of [1, 2, 3, 4, 5, 6]" 
                 type="text" 
                 [id]="'otp' + i"
                 [formControlName]="'d' + i"
                 (input)="onOtpInput($event, i)"
                 (keydown)="onOtpKeydown($event, i)"
                 (paste)="onOtpPaste($event)"
                 maxlength="1"
                 class="w-10 h-12 sm:w-12 sm:h-14 text-center text-xl font-bold bg-[#E9F0E6] border border-gray-200 rounded-lg text-gray-800 focus:ring-2 focus:ring-[#1D4586] outline-none transition-all uppercase" />
        </div>

        <button type="submit" 
                class="w-full bg-[#1D4586] text-white py-3 rounded-lg font-semibold text-lg flex items-center justify-center hover:bg-[#16366b] transition-colors disabled:opacity-50 disabled:cursor-not-allowed" 
                [disabled]="otpForm.invalid || isLoading">
          <svg *ngIf="isLoading" class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          {{ isLoading ? 'Verifying...' : 'Verify OTP' }}
        </button>

        <div class="text-center mt-4">
          <button type="button" (click)="step = 1; isLoading = false; otpForm.reset()" class="text-sm font-semibold text-[#1D4586] hover:underline">
            &larr; Use a different email
          </button>
        </div>
      </form>
    </ng-container>

  </div>

  <footer class="bg-[#E9F0E6] py-3 px-6 flex items-center text-xs text-gray-800 font-medium mt-auto shrink-0">
    <div class="flex items-center">
        <span class="border-r border-gray-400 pr-2 mr-2">Powered by VIGI</span>
        <span>© {{ currentYear }} CleverNav</span>
    </div>
  </footer>

</div>